<template>
	<div style="width:90%"> 
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					
					
					
					<el-form-item label="店铺名称" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item>
					<!-- <el-form-item label="时间">
                        <div class="block">
                            <el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </div>
                    </el-form-item> -->

					<el-form-item label="品牌名称" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.businessName" placeholder="请输入品牌名称"></el-input>
					</el-form-item>
				
					
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="停止" :value="0"></el-option>
							<el-option key="1" label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="店铺属性" class='tiny' cleartable>
						<el-select v-model="searchInfo.storeType" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="线上店铺" :value="0"></el-option>
							<el-option key="2" label="线下店铺" :value="1"></el-option>
						</el-select>
					</el-form-item> -->

				<!-- 	<el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认创建时间降序">
							<el-option key="0" label="更新时间降序" value="0">更新时间降序</el-option>
							<el-option key="1" label="创建时间升序" value="1">创建时间升序</el-option>
							<el-option key="2" label="创建时间降序" value="2">创建时间降序</el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun();title='新增'">新增
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			
			<!-- <el-table-column prop="storeId" label="店铺ID" align="center" :show-overflow-tooltip="true" width="70px">
			</el-table-column> -->
			<!-- <el-table-column prop="enterpriseName" label="企业名称" align="center" :show-overflow-tooltip="true" width="80px">
				
			</el-table-column> -->
			<el-table-column prop="businessName" label="品牌名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="关联店铺" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isActivate" label="是否报单激活" align="center" :show-overflow-tooltip="true" width="120px">
				<template slot-scope="scope">
					<p v-if="scope.row.isActivate == 1">是</p>
					<p v-if="scope.row.isActivate == 0">否</p>
				</template>
			</el-table-column>
			<el-table-column prop="lv1" label="直推奖励(未激活)" align="center" :show-overflow-tooltip="true"  width="140px">
				<template slot-scope="scope">
					{{scope.row.lv1*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="lv1Activate" label="直推奖励(已激活)" align="center" :show-overflow-tooltip="true"  width="140px">
				<template slot-scope="scope">
					{{scope.row.lv1Activate*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="lv2" label="间推奖励(未激活)" align="center" :show-overflow-tooltip="true"  width="140px">
				<template slot-scope="scope">
					{{scope.row.lv2*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="lv2Activate" label="间推奖励(已激活)" align="center" :show-overflow-tooltip="true"  width="140px">
				<template slot-scope="scope">
					{{scope.row.lv2Activate*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v1" label="V1团队管理奖励(比例)" align="center" :show-overflow-tooltip="true"  width="140px">
				<template slot-scope="scope">
					{{scope.row.v1*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v1TeamAmt" label="V1升级要求" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="v2" label="V2团队管理奖励(比例)" align="center" :show-overflow-tooltip="true"  width="110px">
				<template slot-scope="scope">
					{{scope.row.v2*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v2TeamAmt" label="V2升级要求" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="v3" label="V3团队管理奖励(比例)" align="center" :show-overflow-tooltip="true"  width="110px">
				<template slot-scope="scope">
					{{scope.row.v3*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v3TeamAmt" label="V3升级要求" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="v4" label="V4团队管理奖励(比例)" align="center" :show-overflow-tooltip="true"  width="110px">
				<template slot-scope="scope">
					{{scope.row.v4*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v4TeamAmt" label="V4升级要求" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="v5" label="V5团队管理奖励(比例)" align="center" :show-overflow-tooltip="true"  width="110px">
				<template slot-scope="scope">
					{{scope.row.v5*100}}%
				</template>
			</el-table-column>
			<el-table-column prop="v5TeamAmt" label="V5升级要求" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="status" label="奖励启用状态" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">停止</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</p>
				</template>
			</el-table-column>

		

			<el-table-column prop="createTime" label="注册时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center" width="200">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row);title='编辑'">编辑</el-button>
					
					<!-- <el-button size="small" type="text" @click="storeGoodsDialog(scope.row)">店铺商品</el-button> -->

					<el-button size="small" type="text"  @click="editStatusShow(scope.row)">
						{{scope.row.status ? '禁用':'启用'}}</el-button>
					
				<!-- 	<el-button v-if="scope.row.status==0"  size="small" type="text"
						@click="toExamine(scope.row.id, 1)">通过</el-button>
					<el-button v-if="scope.row.status==0" size="small"
					 type="text" @click="toExamine(scope.row.id, 2)">驳回</el-button> -->
					　　　　
				</template>
				　　</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 店铺审核 -->
		<el-dialog style="float:rigin" title="审核" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false" >
			
			<div class="app-container" v-if="auditType==2">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium" >
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button :loading="checkLoading" type="primary" v-if="auditType==2"
					@click="editStoreInfoCheck(storeId,2)">驳回</el-button>
				<el-button :loading="checkLoading" type="primary" v-if="auditType==1"
				@click="editStoreInfoCheck(storeId,1)">通过</el-button>
				
				<el-button @click="cannelPass">取 消</el-button>
			</div>
		</el-dialog>
		
		<!-- 禁用 或 启用 -->
		<el-dialog style="float:rigin" :title="formStatus.status ? '禁 用':'启 用'" :visible.sync="editStatusDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div class="app-container">
				<el-form ref="form" :model="formStatus" :rules="mainFormRules" size="medium">
					<el-form-item label="禁用说明:" v-show="formStatus.status">
						<el-col :span="18">
							<el-input v-model="formStatus.refuseReason" placeholder="请输入禁用说明" />
						</el-col>
					</el-form-item>
					
					<div style="text-align: center;">
						<el-button :loading="toStatusLoading" type="primary" @click="toStatus()">{{formStatus.status ? '禁 用':'启 用'}}
						</el-button>
						<el-button @click="editStatusDialogVisible = false">取 消</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>


		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible" width="50%" >
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium" label-width="120px">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						
						<el-form-item  label="品牌名称" >
							<!-- {{storeInfo.storeName}} -->
							<el-select filterable v-model="storeInfo.businessId" placeholder="请输入商家" 
							clear  style="width:200px;"
								:remote-method="getUserList"
								:loading="storeLoading"
								remote
								@change="changes"
								:disabled="title=='新增'?false:true"
								reserve-keyword>
								<el-option v-for="item in accountList" 	 :key="item.id" :value="item.id" :label="item.businessName">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="关联用户" v-else >
						
							<span v-if="storeInfo.username">{{storeInfo.username}}</span>
							
						</el-form-item> -->
						
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;" v-if="storeInfo.storeName">
						<el-form-item label="关联商家"  >
							{{storeInfo.storeName}}
						</el-form-item>

						
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="是否报单激活" label-width="500">
							<el-switch v-model="storeInfo.isActivate" :active-value="true" :inactive-value="false">
						</el-switch>
						</el-form-item>
						<el-form-item label="激活金额" v-if="storeInfo.isActivate==1" label-width="500">
							<el-input type="text" v-model="storeInfo.activateAmount" style="width: 120px;" placeholder="请输入直推奖励" />
						</el-form-item>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="直推奖励(未激活)" label-width="500">
							<el-input type="text" v-model="storeInfo.lv1"  style="width: 150px;" placeholder="请输入直推奖励" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="直推奖励(已激活)" label-width="500">
							<el-input type="text" v-model="storeInfo.lv1Activate" style="width: 150px;" placeholder="请输入直推奖励" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="间推奖励(未激活)" label-width="500">
							<el-input type="text" v-model="storeInfo.lv2" style="width: 150px;" placeholder="请输入间推奖励" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="间推奖励(已激活)" label-width="500">
							<el-input type="text" v-model="storeInfo.lv2Activate" style="width: 150px;" placeholder="请输入间推奖励" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="V1团队管理奖励(比例)" label-width="500">
							<el-input type="text" v-model="storeInfo.v1" style="width: 120px;" placeholder="请输入比例" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="V1升级要求" label-width="500">
							<el-input type="text" v-model="storeInfo.v1TeamAmt" style="width: 120px;" placeholder="升级要求" />
						</el-form-item>
					</div>
					
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="V2团队管理奖励(比例)" label-width="500">
							<el-input type="text" v-model="storeInfo.v2" style="width: 120px;" placeholder="请输入比例" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="V2升级要求" label-width="500">
							<el-input type="text" v-model="storeInfo.v2TeamAmt" style="width: 120px;" placeholder="升级要求" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="V3团队管理奖励(比例)" label-width="500">
							<el-input type="text" v-model="storeInfo.v3" style="width: 120px;" placeholder="请输入比例" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="V3升级要求" label-width="500">
							<el-input type="text" v-model="storeInfo.v3TeamAmt" style="width: 120px;" placeholder="升级要求" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="V4团队管理奖励(比例)" label-width="500">
							<el-input type="text" v-model="storeInfo.v4" style="width: 120px;" placeholder="请输入比例" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="V4升级要求" label-width="500">
							<el-input type="text" v-model="storeInfo.v4TeamAmt" style="width: 120px;" placeholder="升级要求" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="V5团队管理奖励(比例)" label-width="500">
							<el-input type="text" v-model="storeInfo.v5" style="width: 120px;" placeholder="请输入比例" />
							<span style="padding-left: 10px;">%</span>
						</el-form-item>
						<el-form-item label="V5升级要求" label-width="500">
							<el-input type="text" v-model="storeInfo.v5TeamAmt" style="width: 120px;" placeholder="升级要求" />
						</el-form-item>
					</div>
					
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-if="title=='新增'" type="primary" @click="sure" :loading="sureLoading">添 加</el-button>
				<el-button v-if="title=='编辑'" type="primary" @click="edit" :loading="editLoading">修 改</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('store');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				editStatusDialogVisible: false,//禁用或启用
				formStatus:{},
				accountList: [],
				username: '',
				regionId:'',
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					storeType:'', 
				},
				store_logo: [], //店铺logo
				provinceList: {},
				cityList: {},
				districtList: {},
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					isHot: '',
					checkState: '',
					status: '',
					storeType: ''

				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				dialogVisibleDetails:false, //logo查看弹窗
				storeLoading: false,
				auditInfo: {}, //店铺审核信息
				auditType: '', //店铺审核类型

				licensePhoto:[], //店铺营业执照
				fileList: [], //证件照片
				fileListTwo: [], //店铺照片

				dialogImg:false,
				popupImageUrl:'',

				BusinessCategory:[], //经营类别
				mainBusinessCategory:[],
				storeGoodsFlag: false,
				poupName: '1',
				poupStoreName: '',
				poupStoreID: 0,

				storeTypeFlage: 0,
				findGoodInfo: {},
				storeGoodsList: [],
				goodLoadingOne: false,

				findGoodInfoTwo: {},
				storeGoodsListTwo: [],
				goodLoadingTwo: true,
				pageGood: {
					pageNum: 1,
					pageSize: 10,

					pageNumTwo: 1,
					pageSizeTwo: 10
				},
				

				detail: '',
				images: [],
				detailType: 0,

				stoId: '', //用户ID

				sureLoading: false,
				editLoading: false,


				storeZCFlage: false,
				storeRecordList: {},
				storeRecordLoading: false,
				pageStoreRecord: {
					pageNum: 1,
					pageSize: 10,
				},
				storeZCInfo: {},
				searchStoreZCInfo: {
					changeType: null,
					timer: [],
					source: ''
				},
				typeList: [],

				checkLoading: false, //审核
				toStatusLoading: false, //禁用或启用
			};
		},

		methods: {
			tchange(e){
				console.log(e);
			},
			toStoreZC(row){  //资产变动记录
				this.storeZCInfo = row;
				this.storeZCFlage = true;
				this.storeRecordList = {};
				this.searchStoreZCInfo =  {
					changeType: null
				};
				this.pageStoreRecord.pageNum = 1;
				this.pageStoreRecord.pageSize = 10;
				this.getStoreRecordList();
				this.getRecordTypeList();
			},
			changes(e){
				console.log(this.accountList.find(item=>item.id==e));
				this.storeInfo.storeId=this.accountList.find(item=>item.id==e).storeId
				this.storeInfo.storeName=this.accountList.find(item=>item.id==e).storeName
				
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
			emptyStoreZC() {
				this.searchStoreZCInfo = {}
			},
			searchStoreZCClick() {
				this.pageStoreRecord.pageNum = 1;
				this.getStoreRecordList();
			},
			pageChangeStoreZC(data) {
				this.pageStoreRecord.pageNum = data
				this.getStoreRecordList()
			},
			handleSizeChangeStoreZC(val) {
				this.pageStoreRecord.pageSize = val
				this.getStoreRecordList()
			},
			getStoreRecordList(){
				let data = {
					storeId: this.storeZCInfo.id,

					pageNum: this.pageStoreRecord.pageNum,
					pageSize: this.pageStoreRecord.pageSize,

					startTime: this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[0] : "",
                    endTime:  this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[1] : "" ,
					changeType: this.searchStoreZCInfo.changeType,
					source: this.searchStoreZCInfo.source,
				}
				this.$api.storeAssetChangesList(data).then((res) => {
					if (res.state == 'success') {
						this.storeRecordList = res.data
					} else {
						this.$message.error(res.message)
					}
					this.storeRecordLoading = false
				})
			},
			storeGoodsDialog(item){ //店铺商品弹窗
				this.storeGoodsList = [];
				this.storeGoodsListTwo = [];
				this.findGoodInfo = {};
				this.findGoodInfoTwo = {};
				this.poupName = '1';

				this.storeTypeFlage = item.storeType;
				this.poupStoreID = item.id;
				this.poupStoreName = item.storeName;
				this.storeGoodsFlag=true;

				this.getStoreGoodsList()
				if(item.storeType==1){
					this.getStoreGoodsListTwo();
				}
			},
			searchGood(){ //条件查询商品
				this.pageGood.pageNum = 1
				this.getStoreGoodsList();
			},
			emptyOne(){
				this.findGoodInfo = {}
			},
			pageChangeOne(val){
				this.pageGood.pageNum = val
				this.getStoreGoodsList()
			},
			handleSizeChangeOne(val){
				this.pageGood.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.goodLoadingOne = true
				this.findGoodInfo.orderType = 3;
				this.findGoodInfo.storeId = this.poupStoreID;
				this.findGoodInfo.pageNum = this.pageGood.pageNum;
				this.findGoodInfo.pageSize = this.pageGood.pageSize;
				this.$api.getStoreGoodsList({...this.findGoodInfo,goodsType:1}).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsList = res.data
						this.goodLoadingOne = false
					}
				})
			},

			searchGoodTwo(){ //条件查询商品
				this.pageGood.pageNumTwo = 1
				this.getStoreGoodsListTwo();
			},
			emptyTwo(){
				this.findGoodInfoTwo = {}
			},
			pageChangeTwo(val){
				this.pageGood.pageNumTwo = val
				this.getStoreGoodsListTwo()
			},
			handleSizeChangeTwo(val){
				this.pageGood.pageSizeTwo = val
				this.getStoreGoodsListTwo()
			},
			getStoreGoodsListTwo() {
				this.goodLoadingTwo = true
				this.findGoodInfoTwo.storeId = this.poupStoreID;
				this.findGoodInfoTwo.pageNum = this.pageGood.pageNumTwo;
				this.findGoodInfoTwo.pageSize = this.pageGood.pageNumTwo;
				this.$api.ssGoodsList(this.findGoodInfoTwo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsListTwo = res.data
						this.goodLoadingTwo = false
					}
				})
			},

			getBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					
				}
				this.$api.findipoBusinessNature(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.BusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			getmainBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					
				}
				this.$api.findipoBusinessClassify(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.mainBusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.store_logo.push({
					url: response.message
				})
			},
			handleRemove(file, fileList) {
				this.store_logo = [];
			},

			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList.remove(file);
			},
			onSuccess1Two(response, file) {
				// console.log(response)
				this.fileListTwo.push({
					"url": response.message
				})
			},
			handleRemove1Two(file, fileList) {
				if (file.response) {
					this.fileListTwo.remove(file.response.message);
				}
				this.fileListTwo.remove(file);
			},
		
			handleRemoveTwo(file, fileList) {
				this.licensePhoto = [];
			},
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				// this.dialogVisibleImg = true;

				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			

			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},

			toExamine(id,num){ // 查询店铺详细信息
				//审核驳回弹窗打开
				this.form.refuseReason = ""; //驳回原因
					
				this.auditType = num; //审核类型
				this.auditInfo = {}; //审核数据信息

				this.storeId = id
				this.$api.getStoreId(this.storeId).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.auditInfo = res.data;
						// console.log('审核信息1---',this.auditInfo )
						// this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						// this.auditInfo.storeImages = res.data.storeImages.split(',')
						if(res.data.bankLicenceImage){ //证件照片
							this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						}
						if(res.data.storeImages){  //店铺照片
							this.auditInfo.storeImages = res.data.storeImages.split(',')
						}
						// console.log('审核信息2---',this.auditInfo )
						this.editDialogVisible = true;
					}
				})
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						businessName: e
					}
					this.$api.businessNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}

				
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			//店铺提交审核
			editStoreInfoCheck(id, status) {
				this.checkLoading = true;
				if (status == 2) {
					//通过驳回
					var data = {
						id: this.storeId,
						status: status,
						reason: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						status: status
					}
				}
				this.$api.updateStatusBusiness(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreList()
					} else {
						this.$message.error(res.message);
					}
					this.checkLoading = false;
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			
		
			// 店铺编辑弹窗
			dialogVisibleFun(it) {
				this.storeInfo = {}
				this.storeId = ""
				this.regionId = '';
				this.store_logo = [];
				this.licensePhoto = [];
				this.fileList = [];
				this.fileListTwo = [];

				if (it) {
					this.storeId = it.id
					this.$api.findByIdstoreRewardSetting(it.id).then(res=>{
						this.storeInfo=res.data
						this.storeInfo.lv1=this.storeInfo.lv1*100
						this.storeInfo.lv1Activate=this.storeInfo.lv1Activate*100
						this.storeInfo.lv2=this.storeInfo.lv2*100
						this.storeInfo.lv2Activate=this.storeInfo.lv2Activate*100
						this.storeInfo.v1=this.storeInfo.v1*100
						this.storeInfo.v2=this.storeInfo.v2*100
						this.storeInfo.v3=this.storeInfo.v3*100
						this.storeInfo.v4=this.storeInfo.v4*100
						this.storeInfo.v5=this.storeInfo.v5*100
					})
					this.storeInfo = it;
					
				} 
				this.dialogVisible = true;
			},
			//新增店铺
			sure() {
				
				// console.log('新增数据---',this.storeInfo)
				this.storeInfo.lv1=this.storeInfo.lv1/100
				this.storeInfo.lv1Activate=this.storeInfo.lv1Activate/100
				this.storeInfo.lv2=this.storeInfo.lv2/100
				this.storeInfo.lv2Activate=this.storeInfo.lv2Activate/100
				this.storeInfo.v1=this.storeInfo.v1/100
				this.storeInfo.v2=this.storeInfo.v2/100
				this.storeInfo.v3=this.storeInfo.v3/100
				this.storeInfo.v4=this.storeInfo.v4/100
				this.storeInfo.v5=this.storeInfo.v5/100
				this.sureLoading = true;
				this.$api.addstoreReward(this.storeInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})

			},
			//编辑
			edit() {				
				this.storeInfo.lv1=this.storeInfo.lv1/100
				this.storeInfo.lv1Activate=this.storeInfo.lv1Activate/100
				this.storeInfo.lv2=this.storeInfo.lv2/100
				this.storeInfo.lv2Activate=this.storeInfo.lv2Activate/100
				this.storeInfo.v1=this.storeInfo.v1/100
				this.storeInfo.v2=this.storeInfo.v2/100
				this.storeInfo.v3=this.storeInfo.v3/100
				this.storeInfo.v4=this.storeInfo.v4/100
				this.storeInfo.v5=this.storeInfo.v5/100
				this.editLoading = true;
				// console.log('编辑数据---', data)
				this.$api.upstoreReward({...this.storeInfo}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
					}
					this.editLoading = false;
				})
			},
			editStatusShow(store){
				let that=this
				let str;
				if (store.status == 0) {
					str = "此操作将启用该品牌分成, 是否继续?"
				} else {
					str = "此操作将禁用该品牌分成, 是否继续?"
				}
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log('点击了确定')
					that.$api.changeStatusstoreReward({id:store.id,status:store.status==1?0:1}).then((res) => {
						if (res.state == 'success') {
							that.$message({
								message: res.message,
								type: 'success'
							});
							that.getStoreList();
							that.editStatusDialogVisible = false;
						} else {
							that.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//禁用启用
			toStatus() {
				this.toStatusLoading = true;
				let str;
				this.$api.changeStatusstoreReward({id:this.formStatus.id,status:this.formStatus.status==1?0:1}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreList();
						this.editStatusDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.toStatusLoading = false;
				})
				// if (this.formStatus == 0) {
				// 	str = "此操作将启用该店铺账号, 是否继续?"
				// } else {
				// 	str = "此操作将禁用该店铺账号, 是否继续?"
				// }
				// this.$confirm(str, '提示', {
				// 	confirmButtonText: '确定',
          		// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	console.log('点击了确定')
				// 	that.$api.editStoreBlockUpOrStartUsing(that.formStatus).then((res) => {
				// 		if (res.state == 'success') {
				// 			that.$message({
				// 				message: res.message,
				// 				type: 'success'
				// 			});
				// 			that.getStoreList();
				// 			that.editStatusDialogVisible = false;
				// 		} else {
				// 			that.$message.error(res.message);
				// 		}
				// 	})
				// }).catch(() => {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					 ...this.searchInfo,
					
				}

				this.$api.findListstoreReward(data).then((res) => { //管理列表
					console.log('店铺管理列表:', res.data.list[0]);
					if (res.state == 'success') {
						this.storeList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},

			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 上传店铺logo点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传店铺logo上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			
			// 上传营业执照点击文件触发
			handlePreviewTwo(file) {
				// console.log(file)
			},
			// 上传营业执照 上传图片前，筛选
			beforeAvatarUploadTwo(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//上传营业执照
			onSuccessTwo(response, file, fileList) {
				// console.log(response);
				this.licensePhoto.push({
					url : response.message
				});
			},

			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.stoId = res.data.storeId; // storeId：0(平台)   
					}
				})
				
			}
		},
		created() {
			this.getStoreList();
			//查询省
			this.$api.businessNameList({}).then((res) => {
				if (res.state == 'success') {
					if (res.data && res.data.length) {
						// this.$message({
						// 	message: '查询成功，请选择用户！',
						// 	type: 'success'
						// });
						this.accountList = res.data
					} else {
						this.$message.error("未查询到用户");
					}
				}else{
					this.$message.error(res.message);
				}
				this.storeLoading = false
			})
		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>